/* DESPI — remontee des incidents du NAVIGATEUR.
   Expose window.despiTrace(code, detail). Charge en PREMIER, avant tout le reste.

   POURQUOI CE FICHIER EXISTE. La moitie des pannes qui coutent des ventes n'atteignent
   jamais le serveur. Un script qui casse sur un modele de telephone, une image qui ne
   charge pas, un bouton sans effet, une requete avalee par la WebView de Meta : cote
   serveur tout parait normal. C'est le pire cas de figure — on ne cherche pas ce qu'on
   ne voit pas, et on ne le decouvre qu'en comptant les ventes manquantes.

   IL DOIT ETRE CHARGE EN PREMIER. Une erreur survenue avant l'installation des ecouteurs
   n'est capturee par personne, et ce sont justement les erreurs de demarrage — celles qui
   cassent toute la page — qui comptent le plus.

   TROIS REGLES.
   1. Rien ici ne doit jamais interrompre le parcours. Un journal qui casse la vente qu'il
      surveille serait le comble : tout est enveloppe, tout echoue en silence.
   2. Aucune donnee personnelle. On envoie des codes, des messages techniques et des
      adresses de page — jamais le contenu d'un champ, jamais une photo, jamais un email.
   3. On groupe et on plafonne. Une boucle cassee peut lever mille erreurs par seconde :
      sans plafond, le journal ferait tomber le site qu'il observe.
*/
(function () {
  'use strict';

  var API = (window.DESPI_API_BASE || 'https://despi-backend.vercel.app').replace(/\/$/, '');
  // Collecte et tableau de bord partagent un point : le plan Vercel Hobby plafonne a
  // douze fonctions. La methode HTTP les separe (POST ecrit, GET lit).
  var POINT = API + '/api/incidents';

  var MAX_LOT = 20;          // taille d'un envoi
  var MAX_PAR_PAGE = 60;     // au-dela, cette page se tait : elle est manifestement en boucle
  var DELAI_ENVOI = 2000;    // regroupement : on laisse les erreurs voisines arriver
  var LENTEUR_MS = 8000;     // un appel plus long que cela est un abandon en puissance

  /* Capture du `fetch` d'origine AVANT de l'envelopper plus bas. Le journal doit expedier
     par cette reference et non par `window.fetch` : sinon il se mesurerait lui-meme, et
     un point de collecte en panne generait des incidents « point de collecte en panne »
     a chaque tentative — une boucle qui ne s'arrete jamais. */
  var fetchOrigine = typeof window.fetch === 'function' ? window.fetch : null;

  var file = [];
  var envoyes = 0;
  var minuteur = null;
  var vus = Object.create(null);   // code+message deja remontes par cette page

  function session() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)despi_sid=([^;]+)/);
      if (m) return decodeURIComponent(m[1]);
      return localStorage.getItem('despi_sid') || '';
    } catch (e) { return ''; }
  }

  /* Envoi. `sendBeacon` d'abord : c'est le SEUL moyen fiable de faire partir quelque chose
     quand la page se ferme — et une page qui se ferme brutalement est precisement le cas
     ou l'on veut savoir pourquoi. `fetch(keepalive)` en secours. */
  function expedier() {
    minuteur = null;
    if (!file.length) return;
    var lot = file.splice(0, MAX_LOT);
    // sendBeacon ne permet aucun en-tete : la session voyage donc dans le CORPS, et le
    // serveur la lit aux deux endroits. Sans cela, tout ce qui part a la fermeture de la
    // page — c'est-a-dire les pannes les plus interessantes — arriverait anonyme.
    var charge = JSON.stringify({ evenements: lot, session: session() });
    var parti = false;
    try {
      if (navigator.sendBeacon) {
        /* `text/plain` et non `application/json`, volontairement : seuls trois types de
           contenu echappent au controle prealable CORS, et `application/json` n'en fait
           pas partie. Avec lui, le navigateur enverrait d'abord un OPTIONS — que la page
           en train de se fermer n'a plus le temps d'attendre, et l'envoi serait perdu
           exactement dans le cas ou il compte le plus. Le serveur analyse le corps sans
           regarder ce type. */
        parti = navigator.sendBeacon(POINT, new Blob([charge], { type: 'text/plain;charset=UTF-8' }));
      }
    } catch (e) { /* quota de beacon atteint, on bascule */ }
    if (!parti && fetchOrigine) {
      try {
        fetchOrigine.call(window, POINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-despi-session': session() },
          body: charge,
          keepalive: true,
          mode: 'cors',
        }).catch(function () { /* le journal ne se plaint jamais de lui-meme */ });
      } catch (e) { /* rien */ }
    }
    // Le reste de la file ne doit pas rester en plan : au-dela d'un lot, on reprogramme.
    if (file.length) planifier();
  }

  function planifier() {
    if (minuteur) return;
    minuteur = setTimeout(expedier, DELAI_ENVOI);
  }

  /**
   * Remonte un incident.
   * @param {string} code  l'un des codes acceptes par le serveur (liste fermee)
   * @param {object} [detail] tout ce qui aide a rejouer la panne
   */
  function tracer(code, detail) {
    try {
      if (envoyes >= MAX_PAR_PAGE) return;

      var d = detail || {};
      var message = String(d.message || d.msg || '').slice(0, 400);

      /* Meme panne = une seule remontee par page. Sans cela, une erreur dans un
         gestionnaire d'evenement envoie autant de lignes que de mouvements du doigt. */
      var cle = code + '|' + message;
      if (vus[cle]) { vus[cle]++; return; }
      vus[cle] = 1;

      envoyes++;
      var detailFinal = {
        ecran: (window.innerWidth || 0) + 'x' + (window.innerHeight || 0),
        // dit si l'on est dans la WebView de Facebook ou d'Instagram : c'est la ou les
        // bugs specifiques se produisent, et on ne peut pas le deviner autrement.
        webview: /FBAN|FBAV|Instagram/i.test(navigator.userAgent || ''),
        reseau: (navigator.connection && navigator.connection.effectiveType) || null,
        depuis: Math.round((window.performance && performance.now()) || 0),
      };
      // On recopie le detail fourni sans ecraser le contexte ci-dessus, et sans repeter
      // les champs deja hisses au niveau superieur.
      for (var k in d) {
        if (Object.prototype.hasOwnProperty.call(d, k)
            && k !== 'message' && k !== 'msg' && k !== 'generationId') {
          detailFinal[k] = d[k];
        }
      }

      file.push({
        code: code,
        message: message,
        url: String(location.href).slice(0, 300),
        generationId: d.generationId || null,
        detail: detailFinal,
      });
      planifier();
    } catch (e) { /* le journal ne fait jamais tomber la page */ }
  }

  window.despiTrace = tracer;

  /* ---------------------------------------------------------- captures automatiques */

  window.addEventListener('error', function (ev) {
    // Deux evenements portent le meme nom : l'erreur JavaScript (a une cible window) et
    // l'echec de chargement d'une ressource (a une cible <img>, <script>, <link>). La
    // seconde ne remonte QU'EN phase de capture, d'ou le `true` plus bas — c'est la raison
    // pour laquelle les images cassees echappent a la plupart des journaux.
    var cible = ev.target;
    if (cible && cible !== window && cible.tagName) {
      var src = cible.src || cible.href || '';
      if (!src) return;
      tracer('ressource_cassee', {
        message: cible.tagName.toLowerCase() + ' : ' + String(src).slice(0, 200),
        balise: cible.tagName.toLowerCase(),
        source: String(src).slice(0, 200),
      });
      return;
    }
    tracer('js_exception', {
      message: (ev.message || 'erreur inconnue') + ' @' + (ev.filename || '?') + ':' + (ev.lineno || 0),
      pile: ev.error && ev.error.stack ? String(ev.error.stack).slice(0, 900) : null,
    });
  }, true);

  window.addEventListener('unhandledrejection', function (ev) {
    var r = ev.reason;
    tracer('js_promesse', {
      message: (r && (r.message || r.error || r)) ? String(r.message || r).slice(0, 300) : 'promesse rejetee',
      pile: r && r.stack ? String(r.stack).slice(0, 900) : null,
      statut: r && r.status ? r.status : null,
    });
  });

  /* Tout appel a NOTRE backend est mesure. Les appels sortants d'autrui (pixel, polices)
     ne nous regardent pas : les compter noierait le signal. */
  if (fetchOrigine) {
    window.fetch = function (entree, options) {
      var url = '';
      try { url = typeof entree === 'string' ? entree : (entree && entree.url) || ''; } catch (e) { url = ''; }
      var notre = url.indexOf(API) === 0 || url.indexOf('/cart/') === 0 || url.indexOf('/checkout') === 0;
      if (!notre) return fetchOrigine.apply(this, arguments);

      var t0 = (window.performance && performance.now()) || 0;
      var chemin = url.replace(API, '').split('?')[0].slice(0, 120);

      return fetchOrigine.apply(this, arguments).then(function (r) {
        var ms = Math.round(((window.performance && performance.now()) || 0) - t0);
        // 402 et 422 sont des refus METIER (quota atteint, aucun sujet sur la photo) :
        // le systeme fonctionne comme prevu, les consigner ferait du bruit pour rien.
        if (!r.ok && r.status !== 402 && r.status !== 422) {
          tracer('api_echec', { message: chemin + ' -> ' + r.status, chemin: chemin, statut: r.status, ms: ms });
        } else if (ms > LENTEUR_MS) {
          tracer('api_lente', { message: chemin + ' en ' + ms + ' ms', chemin: chemin, ms: ms });
        }
        return r;
      }, function (e) {
        var ms = Math.round(((window.performance && performance.now()) || 0) - t0);
        // Un appel qui n'aboutit meme pas : coupure reseau, WebView qui fige, CORS casse.
        tracer('api_echec', {
          message: chemin + ' injoignable : ' + (e && e.name === 'AbortError' ? 'delai depasse' : (e && e.message) || 'reseau'),
          chemin: chemin, ms: ms, reseau: true,
        });
        throw e;
      });
    };
  }

  /* La page part : on expedie ce qui reste plutot que de le perdre. `pagehide` est le seul
     evenement fiable sur iOS — `beforeunload` n'y est pas garanti. */
  window.addEventListener('pagehide', expedier);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') expedier();
  });
})();
